import React, { Component } from 'react';
import { Row, Col } from 'antd';
import {
  StyledButton,
  AddressButton,
  StyledVerticalDrawer
} from 'components/Styled';

class AddressDrawer extends Component {
  state = {};

  render() {
    const selectedAddress = this.props.selectedAddress;

    return (
      <div>
        <StyledVerticalDrawer
          placement="bottom"
          onClose={this.props.onClose}
          visible={this.props.visible}
          height="100%"
          closable={true}>
          <div
            style={{
              height: '100%',
              overflow: 'auto',
              padding: '24px 15px 36px'
            }}>
            <div style={{ padding: '5px 5px 15px' }}>
              <Row type="flex" align="middle" gutter={14}>
                <Col span={9}>
                  <div style={{ fontWeight: 700, fontSize: '16px' }}>
                    {this.props.fromAddress
                      ? this.props.t('pickup.form.select_p_address')
                      : this.props.t('pickup.form.select_r_address')}
                  </div>
                </Col>
                <Col span={15}>
                  <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                    <StyledButton
                      type="primary"
                      ghost
                      width={165}
                      onClick={this.props.addAddress}>
                      {`+ ${this.props.t('pickup.form.add_new')}`}
                    </StyledButton>
                  </div>
                </Col>
              </Row>
            </div>
            <div>
              {this.props.addresses.map(address => {
                let selected = false;
                if (address.ref === selectedAddress) {
                  selected = true;
                }

                return (
                  <AddressButton
                    key={address.ref}
                    className={selected ? 'popup-background' : ''}
                    style={{ backgroundColor: selected ? '#E9F5F5' : '#fff' }}
                    onClick={() => {
                      this.props.onClose();
                      this.props.handleAddressClick(address.ref);
                    }}>
                    <Row type="flex" align="middle" gutter={14}>
                      <Col span={9}>
                        <div style={{ fontWeight: 700, color: '#2C2C2E' }}>
                          {address.name}
                        </div>
                        <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                          {address.phoneCc ? `+${address.phoneCc} ` : ''}{' '}
                          {address.phone}
                        </div>
                      </Col>
                      <Col span={15}>
                        <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                          <div>{address.city || address.area}</div>
                          <div>
                            {address.street1}
                            {address.street2 ? '，' + address.street2 : null}
                            {address.street3 ? '，' + address.street3 : null}
                          </div>
                          {address.company ? (
                            <div>{address.company}</div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </AddressButton>
                );
              })}
            </div>
          </div>
        </StyledVerticalDrawer>
      </div>
    );
  }
}

export default AddressDrawer;
